import { DealerTiersPortalConfiguration } from '../types';

export const dealerTiersPortalConfiguration: DealerTiersPortalConfiguration = {
  tiers: [
    { label: 'Platinum', value: 'PLATINUM', dealerSubsidyContribution: 0 },
    { label: 'Gold', value: 'GOLD', dealerSubsidyContribution: 0 },
    { label: 'Non-Qualified', value: 'NON_QUALIFIED', dealerSubsidyContribution: 0 },
  ],
};
